import React, {useState} from 'react'
import {useDispatch, useSelector} from "react-redux";
import {
    setCnASearchHideResults,
    setCnASearchParams
} from "../../../../../store/user_organizations/teams/tools/connect_and_align/cnASearchSlice";
import {SearchResultsByUser} from "./SearchResultsByUser";

export const SearchResults = () => {
    const team_obj = useSelector((state: any) => state.organization_team);
    const dispatch = useDispatch();
    const tool_cna_search = useSelector((state: any) => state.tool_cna_search)
    const cna = useSelector((state: any) => state.tool_cna)

    if(!tool_cna_search.show_results) {
        return <></>
    }

    const closeSearchResultsHandled = () => {
        dispatch(setCnASearchHideResults())
    }

    let selected_user = tool_cna_search?.search_params?.member?.value;

    let member_list;
    if(selected_user == 'Members (All)') {
        member_list = team_obj?.data?.members;
    } else {
        member_list = team_obj?.data?.members?.filter((member: { id: number; }) => (member.id == selected_user))
    }

    // Helper function to calculate total matches for a member
    const getMemberTotalMatches = (member: any): number => {
        const cna_data = cna?.data || [];
        const cna_archived_data = cna?.archived_data || [];
        
        const user_data = cna_data.find((data: any) => data.user_id == member.id);
        const user_archived_data = cna_archived_data.find((data: any) => data.user_id == member.id);

        if (!user_data && !user_archived_data) return 0;

        const tools = ['tomis', 'deliverables', 'activities', 'messages'];
        const selectedTypes = tool_cna_search.search_params.types;
        let totalMatches = 0;

        tools.forEach((tool) => {
            if (selectedTypes.includes('all') || selectedTypes.includes(tool)) {
                let filteredData: any = [];
                const cnaMemberData = user_data?.[tool]?.data || [];
                const cnaMemberDataArchived = user_archived_data?.[tool]?.data || [];

                if (tool_cna_search.search_params.include.includes('active')) {
                    filteredData = [...cnaMemberData];
                }
                if (tool_cna_search.search_params.include.includes('archive')) {
                    filteredData = [...filteredData, ...cnaMemberDataArchived];
                }

                // Apply search query filter
                if (tool_cna_search?.search_params?.q != undefined && tool_cna_search.search_params.q.trim() != '') {
                    const query = tool_cna_search.search_params.q.toLowerCase();
                    filteredData = filteredData.filter((item: any) => {
                        const title = item.title ? item.title.toLowerCase() : '';
                        const description = item.description ? item.description.toLowerCase() : '';
                        return title.includes(query) || description.includes(query);
                    });
                }

                // Apply date range filter
                if (tool_cna_search?.search_params?.date_start != undefined || tool_cna_search?.search_params?.date_end != undefined) {
                    const moment = require('moment');
                    filteredData = filteredData.filter((item: any) => {
                        const dateCreated = moment(item.dateCreated);
                        const startDate = tool_cna_search.search_params.date_start;
                        const endDate = tool_cna_search.search_params.date_end;
                        return (!startDate || dateCreated.isSameOrAfter(startDate)) &&
                            (!endDate || dateCreated.isSameOrBefore(endDate));
                    });
                }

                totalMatches += filteredData.length;
            }
        });

        return totalMatches;
    };

    // Filter out members with zero matches
    const membersWithResults = member_list.filter((member: any) => {
        const totalMatches = getMemberTotalMatches(member);
        return totalMatches > 0;
    });

    // Calculate total results across all members
    const totalResults = membersWithResults.reduce((sum: number, member: any) => {
        return sum + getMemberTotalMatches(member);
    }, 0);

    return (
        <>
            <div className="card">
                <div className="modal-header">
                    <h5 className="card-title">Search Results</h5>
                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={closeSearchResultsHandled}></button>
                </div>
                <div className="card-body container">
                    {membersWithResults.length > 0 && (
                        <div className="row mb-3">
                            <div className="col-12">
                                <p className="text-muted mb-0">
                                    <strong>{totalResults}</strong> result{totalResults !== 1 ? 's' : ''} found across <strong>{membersWithResults.length}</strong> team member{membersWithResults.length !== 1 ? 's' : ''}
                                </p>
                            </div>
                        </div>
                    )}
                    <div className="row">
                        {membersWithResults.length > 0 ? (
                            membersWithResults.map((member:any) => (
                                <SearchResultsByUser key={member.id} member={member}  />
                            ))
                        ) : (
                            <div className="col-12 text-center py-4">
                                <p className="text-muted mb-3">No results found for your search criteria.</p>
                                <button 
                                    type="button" 
                                    className="btn btn-secondary"
                                    onClick={() => {
                                        // Hide search results
                                        dispatch(setCnASearchHideResults());
                                        // Dispatch custom event to reopen search modal
                                        window.dispatchEvent(new CustomEvent('openSearchModal'));
                                    }}
                                >
                                    Try Again
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>

        </>
    )
}
